import { render, staticRenderFns } from "./OpenBankingTag.vue?vue&type=template&id=d9bc012a&scoped=true"
import script from "./OpenBankingTag.vue?vue&type=script&lang=js"
export * from "./OpenBankingTag.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingTag.vue?vue&type=style&index=0&id=d9bc012a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bc012a",
  null
  
)

export default component.exports